import React, { useCallback, useContext, useEffect } from 'react'

import API from '../../../../../services/api'
import Banner from '../../../../atoms/banner/Banner'
import Form from '../../../../atoms/form/Form'
import VerticalGroup from '../../../../atoms/verticalgroup/VerticalGroup'
import { SimulationContext } from '../../context'
import useForm from '../../../../../hooks/useForm'
import EconomyDropdown from './EconomyDropdown'
import TermFundingDropdown from './TermFundingDropdown'
import CapitalManagementDropdown from './CapitalManagementDropdown'
import Toggle from '../../../../atoms/toggle/Toggle'


const Module: React.FC<{}> = () => {
  const { config, updateConfig, assignOnSubmitFunction, updateFormStatus } = useContext(SimulationContext)
  let [
    { formData: {economy, termFunding, capitalManagement, operatingCostsEnabled}, error, inProgress, formUpdated },
    { setDropdownField, setFieldSimple, handleSubmit }
  ] = useForm(config?.moduleSetup ? {
    ...config.moduleSetup
  } : {
    economy: 'vanilla_4_rounds',
    termFunding: 'automatic',
    capitalManagement: 'automatic',
    operatingCostsEnabled: false
  })

  const onSubmit = useCallback(async () => {
    if (config) {
      const payload: API.SimulationUpdateRequest = {
        moduleSetup: {
          economy,
          termFunding,
          capitalManagement,
          operatingCostsEnabled
        }
      }
  
      const response = await API.editSimulation(config.id, payload)
  
      updateConfig(response)
      return response
    }
  }, [config, economy, termFunding, capitalManagement, operatingCostsEnabled, updateConfig])

  useEffect(() => {
    assignOnSubmitFunction(handleSubmit(onSubmit))
  }, [assignOnSubmitFunction, handleSubmit, onSubmit])

  useEffect(() => {
    updateFormStatus({
      inProgress: inProgress,
      formUpdated: formUpdated
    })
  }, [updateFormStatus, inProgress, formUpdated])

  return (
    <div className="step-container">
      <VerticalGroup spread full>
        <VerticalGroup wide>
          <Banner type='error' active={!!error} message={error?.message}/>
          <Form id='simulation-add-form'>
            <h3>Economy Settings</h3>
            <EconomyDropdown label="Economy" onChange={setDropdownField('economy')} value={economy}/>
            <h3>Treasury Settings</h3>
            <TermFundingDropdown label="Term Funding" onChange={setDropdownField('termFunding')} value={termFunding}/>
            <CapitalManagementDropdown label="Capital Management" onChange={setDropdownField('capitalManagement')} value={capitalManagement} />
            <h3>Other Settings</h3>
            <Toggle
              label="Operating Costs"
              helpTitle="Operating Costs"
              helpDescription="This allows participants to adjust investment and resourcing in 4 functional divisions. This will impact financial and non-financial outcomes. e.g Increased Risk & Compliance FTE to reduce unresolved risk incidents."
              checked={operatingCostsEnabled}
              onUpdate={setFieldSimple('operatingCostsEnabled')}
              block
            />
          </Form>
        </VerticalGroup>
      </VerticalGroup>
    </div>
  )
}

export { default as ModuleDisplay } from './Display'
export default Module
